import { HEIGHT_OFF_SET } from "./constants";
export var getIsTopComponentVisible = function getIsTopComponentVisible(_ref, windowHeight) {
  var top = _ref.top;
  return top - HEIGHT_OFF_SET <= windowHeight && top > -windowHeight / 2;
};